import Stack from 'components/commons/stack';
import { styles } from 'modules/addons/style';
import ShippingTab from 'modules/home/order-tabs/shipping-tab';
import * as React from 'react';

interface Props {
  onClose: () => void;
  onSubmit: (values) => void;
  type: string;
  cancelable?: boolean;
}
export default function ShippingRoute(props: Props) {
  const { onClose, cancelable } = props;
  return (
    <Stack
      alignItems="center"
      justify="center"
      rootCss={{
        border: '0 0 12px 12px',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.15)',
        padding: 40,
        height: 'fit-content',
      }}
    >
      <Stack.Item css={{ ...styles.breakPoints }}>
        <ShippingTab
          cancelable={cancelable}
          onCancel={onClose}
          headerCss={{
            display: 'none',
            '@sm': {
              display: 'flex',
            },
          }}
          onSubmit={async (values, queryParams) => {
            props.onSubmit(queryParams);
          }}
          changeRoute
        />
      </Stack.Item>
    </Stack>
  );
}
